var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "flex justify-center items-center h-[50vh]"
};
import { UISpin } from '@gohighlevel/ghl-ui';
import axios from 'axios';
import debounce from 'lodash/debounce';
import { computed, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import BackgroundsAndTextures from '../components/BackgroundsAndTextures.vue';
import CreateFolderModal from '../components/CreateFolderModal.vue';
import Header from '../components/MediaHeaderv2.vue';
import MediaSearchBar from '../components/MediaSearchBar.vue';
import NoFile from '../components/NoFile.vue';
import PixabayImages from '../components/PixabayImages.vue';
import UnsplashImages from '../components/UnsplashImages.vue';
import UploadingIndicator from '../components/UploadingIndicator.vue';
import { useFile } from '../composable/fileUpload';
import { useContentAI } from '../composable/useContentAI';
import useEmitter from '../composable/useEmitter';
import { useEvent } from '../composable/useEvent';
import config from '../config/index';
import MediaService from '../services/MediaService';
import { useStore } from '../store';
import { MIME_TYPES } from '../util/const_helper';
import { randomId } from '../util/helper';
import FilesView from './FilesView.vue';
import FoldersView from './FoldersView.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FileSystemView',
    props: {
        settings: {}
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const { sendNotification } = useEvent();
        const folders = ref([]);
        const files = ref([]);
        const backgrounds = ref([]);
        const textures = ref([]);
        const showFolderModal = ref(false);
        const fileRef = ref();
        const category = ref('my_media');
        const selectedParentId = ref(undefined);
        const mediaLayout = ref('grid');
        const mediaCount = ref(0);
        const initaializePagination = {
            limit: 100,
            offset: 0,
            sortBy: 'updatedAt',
            sortOrder: 'desc',
        };
        // const loading = ref(false)
        const limit = ref(initaializePagination.limit);
        const offset = ref(initaializePagination.offset);
        const sortBy = ref(initaializePagination.sortBy);
        const sortOrder = ref(initaializePagination.sortOrder);
        const pixabayOffset = ref(1);
        const unsplashOffset = ref(1);
        const searchText = ref('');
        const key = ref(1);
        const pixabayImages = ref([]);
        const unsplashImages = ref([]);
        const store = useStore();
        const { openImageGenerationForm } = useContentAI();
        const { uploadFile, validateFileUpload, verifyFileUpload } = useFile();
        const loading = computed({
            get: () => store.loading,
            set: value => {
                store.loading = value;
            },
        });
        const altId = computed(() => store.altId);
        const altType = computed(() => store.altType);
        const contentAIEnable = computed(() => store.contentAIEnable);
        const accordionVisible = computed(() => category.value == 'all' ? true : false);
        const pixabayKeys = ref(config.PIXABAY_KEYS);
        const unsplashClientIds = ref(config.UNSPLASH_CLIENT_IDS);
        const filesFetchedLength = ref(0);
        loading.value = true;
        Promise.all([getFolders(), getFiles()]).finally(() => {
            loading.value = false;
        });
        const emitter = useEmitter();
        const showContentAI = computed(() => {
            if (props.settings.contentType === 'video') {
                return false;
            }
            return true;
        });
        watch(() => { var _a; return (_a = store.directoryRoute) === null || _a === void 0 ? void 0 : _a.length; }, length => {
            var _a, _b, _c;
            console.info('Directory route changed', length);
            selectedParentId.value =
                (_c = (_b = (_a = store === null || store === void 0 ? void 0 : store.directoryRoute) === null || _a === void 0 ? void 0 : _a[length - 1]) === null || _b === void 0 ? void 0 : _b._id) !== null && _c !== void 0 ? _c : undefined;
            clearOldDataAndGetFreshData();
            if (length && length === 0) {
                store.updateDirectory(null);
                return;
            }
        });
        function isHeaderActive() {
            return category.value == 'my_media' ? true : false;
        }
        function onSetCategory(ctEvent) {
            store.activeItem = {};
            category.value = ctEvent ? ctEvent : 'my_media';
            store.updateActiveCategory(category.value);
            key.value += 1;
            if (searchText.value) {
                onSearch(searchText.value);
            }
        }
        function updateFolderData() {
            loading.value = true;
            clearFolderData();
            getFolders();
            loading.value = false;
            showFolderModal.value = false;
        }
        function clearPixabayData() {
            pixabayImages.value = [];
        }
        function clearUnsplashData() {
            unsplashImages.value = [];
        }
        function clearBackgroundsData() {
            backgrounds.value = [];
        }
        function clearTexturesData() {
            textures.value = [];
        }
        function clearFolderData() {
            folders.value = [];
        }
        function clearFileData() {
            files.value = [];
        }
        function clearAll() {
            clearFolderData();
            clearFileData();
        }
        function clearOldDataAndGetFreshData() {
            loading.value = true;
            clearAll();
            offset.value = initaializePagination.offset;
            limit.value = initaializePagination.limit;
            Promise.all([getFolders(), getFiles()]).finally(() => {
                loading.value = false;
            });
        }
        onMounted(() => {
            emitter.on('updateUI', () => {
                if (mediaLayout.value === 'list') {
                    loading.value = true;
                    Promise.all([getFolders(), getFiles()]).finally(() => {
                        loading.value = false;
                    });
                    return;
                }
                clearOldDataAndGetFreshData();
            });
            emitter.on('resetUI', () => {
                clearAll();
                offset.value = initaializePagination.offset;
                limit.value = initaializePagination.limit;
            });
            emitter.on('updateParent', () => {
                const found = folders.value.find(i => (i === null || i === void 0 ? void 0 : i.name) == 'Content AI');
                if (found) {
                    selectedParentId.value = found._id;
                    setTimeout(() => {
                        store.updateDirectory(found);
                    }, 2000);
                }
            });
            // Detecting when user scrolls to bottom of div
            const element = document.getElementById('drop_zone');
            if (element) {
                element.addEventListener('scroll', debounce(() => {
                    if (isScrollAtBottom(element)) {
                        fetchFiles();
                    }
                }, 100));
            }
        });
        function isScrollAtBottom(element) {
            if (!element)
                return false;
            return element.scrollTop + element.clientHeight >= element.scrollHeight;
        }
        function fetchFiles() {
            return __awaiter(this, void 0, void 0, function* () {
                loading.value = true;
                if ((category.value === 'my_media' || category.value === 'all') &&
                    filesFetchedLength.value >= limit.value) {
                    // Infinite scroll for my media
                    offset.value = files.value.length;
                    yield getFiles({ scroll: true });
                    loading.value = false;
                }
                else if (category.value === 'pixabay' &&
                    pixabayImages.value.length >= limit.value) {
                    // Infinite scroll for pixabay
                    pixabayOffset.value += 1;
                    yield getFilesFromPixabay(searchText.value, true);
                    loading.value = false;
                }
                else if (category.value === 'unsplash' &&
                    unsplashImages.value.length >= limit.value) {
                    // Infinite scroll for unsplash
                    unsplashOffset.value += 1;
                    yield getFilesFromUnsplash(searchText.value, true);
                    loading.value = false;
                }
                else {
                    loading.value = false;
                }
            });
        }
        function getBackgrounds(searchTerm) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (!altId.value)
                        return;
                    const { data } = yield MediaService.listBackgrounds({
                        altId: altId.value,
                        altType: altType.value,
                        query: searchTerm || '',
                        sortBy: sortBy.value,
                        sortOrder: sortOrder.value,
                    });
                    if (searchTerm !== undefined) {
                        clearBackgroundsData();
                    }
                    backgrounds.value = data.files;
                }
                catch (error) {
                    console.error(error);
                }
            });
        }
        function getTextures(searchTerm) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (!altId.value)
                        return;
                    const { data } = yield MediaService.listTextures({
                        altId: altId.value,
                        altType: altType.value,
                        query: searchTerm || '',
                        sortBy: sortBy.value,
                        sortOrder: sortOrder.value,
                    });
                    if (searchTerm !== undefined) {
                        clearTexturesData();
                    }
                    textures.value = data.files;
                }
                catch (error) {
                    console.error(error);
                }
            });
        }
        function getFolders(searchTerm) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (!altId.value)
                        return;
                    const { data } = yield MediaService.listFiles({
                        altId: altId.value,
                        altType: altType.value,
                        parentId: selectedParentId.value || '',
                        query: searchTerm || '',
                        type: 'folder',
                        sortBy: sortBy.value,
                        sortOrder: sortOrder.value,
                    });
                    if (searchTerm !== undefined) {
                        clearFolderData();
                    }
                    folders.value = data.files;
                }
                catch (error) {
                    console.error(error);
                }
            });
        }
        function getFilesFromUnsplash(searchTerm, scroll) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (searchTerm) {
                        const url = config.UNSPLASH_API;
                        const clientId = unsplashClientIds.value[0];
                        const params = {
                            client_id: clientId,
                            query: searchTerm,
                            page: unsplashOffset.value,
                            per_page: 30,
                        };
                        const { headers, data } = yield axios.get(url, { params });
                        const rateLimit = headers['x-ratelimit-remaining'];
                        if (rateLimit && rateLimit < 5) {
                            const shiftedKey = unsplashClientIds.value.shift() || '';
                            unsplashClientIds.value.push(shiftedKey);
                        }
                        const files = data.results || [];
                        if (searchTerm !== undefined && !scroll) {
                            clearUnsplashData();
                        }
                        if (scroll) {
                            unsplashImages.value.push(...files);
                        }
                        else {
                            unsplashImages.value = files;
                        }
                    }
                }
                catch (error) {
                    console.error(error);
                }
            });
        }
        function getFilesFromPixabay(searchTerm, scroll) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (searchTerm) {
                        const url = config.PIXABAY_API;
                        const key = pixabayKeys.value[0];
                        const params = {
                            key: key,
                            q: searchTerm,
                            image_type: 'all',
                            page: pixabayOffset.value,
                            per_page: 30,
                        };
                        const { headers, data } = yield axios.get(url, { params });
                        const rateLimit = headers['x-ratelimit-remaining'];
                        if (rateLimit && rateLimit < 5) {
                            const shiftedKey = pixabayKeys.value.shift() || '';
                            pixabayKeys.value.push(shiftedKey);
                        }
                        const files = data.hits || [];
                        if (searchTerm !== undefined && !scroll) {
                            clearPixabayData();
                        }
                        if (scroll) {
                            pixabayImages.value.push(...files);
                        }
                        else {
                            pixabayImages.value = files;
                        }
                    }
                }
                catch (error) {
                    console.error(error);
                }
            });
        }
        function getFiles(params) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (!altId.value)
                        return;
                    let limitValue = mediaLayout.value === 'grid' ? limit.value : 10;
                    if (params === null || params === void 0 ? void 0 : params.fileUpload) {
                        const tempOffset = offset.value;
                        offset.value = 0;
                        limitValue += tempOffset;
                    }
                    if ((params === null || params === void 0 ? void 0 : params.pageCount) >= 0) {
                        offset.value = (params === null || params === void 0 ? void 0 : params.pageCount) * 10;
                    }
                    const { data } = yield MediaService.listFiles({
                        altId: altId.value,
                        altType: altType.value,
                        parentId: selectedParentId.value || '',
                        offset: offset.value,
                        limit: limitValue,
                        query: (params === null || params === void 0 ? void 0 : params.searchTerm) || '',
                        type: 'file',
                        sortBy: sortBy.value,
                        sortOrder: sortOrder.value,
                        contentType: props.settings.contentType,
                    });
                    mediaCount.value = data.count;
                    if ((params === null || params === void 0 ? void 0 : params.searchTerm) !== undefined) {
                        clearFileData();
                    }
                    if (params === null || params === void 0 ? void 0 : params.scroll) {
                        files.value.push(...data.files);
                    }
                    else if ((_a = data === null || data === void 0 ? void 0 : data.files) === null || _a === void 0 ? void 0 : _a.length) {
                        files.value = store.$state.selfHosted
                            ? data.files
                                .map((file) => {
                                return isSupported(file);
                            })
                                .filter((item) => item != undefined)
                            : data.files;
                    }
                    filesFetchedLength.value = data.files.length;
                    loading.value = false;
                }
                catch (error) {
                    console.error(error);
                }
            });
        }
        function isSupported(file) {
            if (!file) {
                return undefined;
            }
            else {
                return MIME_TYPES.video.includes(file.contentType) ? file : undefined;
            }
        }
        function addFilesFromDropZone(e) {
            const droppedFiles = e.dataTransfer.files;
            addFile(droppedFiles);
        }
        function addFile(droppedFiles) {
            if (!droppedFiles)
                return;
            const files = [...droppedFiles];
            files.forEach((file) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const uuId = randomId(8);
                try {
                    validateFileUpload(file);
                    store.addToUploadQueue({
                        name: file.name,
                        uploaded: false,
                        id: uuId,
                    });
                    const data = yield uploadFile({
                        file,
                        parentId: selectedParentId.value || '',
                        trackingProgressId: uuId,
                    });
                    const verifyUpload = yield verifyFileUpload(data.aknId);
                    store.updateUploadQueue(uuId, verifyUpload === null || verifyUpload === void 0 ? void 0 : verifyUpload.url);
                    getFiles({ fileUpload: true });
                    loading.value = false;
                    emitter.emit('calculateStorage');
                }
                catch (error) {
                    console.error(error);
                    sendNotification({
                        type: 'error',
                        duration: 5000,
                        title: (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : 'Something went wrong',
                    });
                }
            }));
        }
        function customFileUpload() {
            fileRef.value.click();
        }
        function handleFileUpload() {
            return __awaiter(this, void 0, void 0, function* () {
                addFile(fileRef.value.files);
                fileRef.value.value = '';
            });
        }
        const onSearch = debounce(function (query) {
            loading.value = true;
            searchText.value = query;
            pixabayOffset.value = 1;
            unsplashOffset.value = 1;
            offset.value = 0;
            store.activeItem = {};
            if (!query) {
                pixabayImages.value = [];
                unsplashImages.value = [];
                key.value += 1;
                getFolders();
                getFiles();
                getBackgrounds();
                getTextures();
            }
            if (category.value == 'my_media') {
                Promise.all([
                    getFolders(searchText.value),
                    getFiles({ searchTerm: searchText.value }),
                ]).finally(() => {
                    loading.value = false;
                });
            }
            else if (category.value == 'backgrounds') {
                Promise.all([
                    getBackgrounds(searchText.value),
                    getTextures(searchText.value),
                ]).finally(() => {
                    loading.value = false;
                });
            }
            else if (category.value == 'unsplash') {
                getFilesFromUnsplash(searchText.value);
                loading.value = false;
            }
            else if (category.value == 'pixabay') {
                getFilesFromPixabay(searchText.value);
                loading.value = false;
            }
            else {
                Promise.all([
                    getFolders(searchText.value),
                    getFiles({ searchTerm: searchText.value }),
                    getBackgrounds(searchText.value),
                    getTextures(searchText.value),
                    getFilesFromPixabay(searchText.value),
                    getFilesFromUnsplash(searchText.value),
                ]).finally(() => {
                    loading.value = false;
                });
            }
        }, 500);
        function sortingOptions(params) {
            sortOrder.value = params.sortOrder ? 'desc' : 'asc';
            sortBy.value = params.sortBy ? params.sortBy.value : 'name';
            store.activeItem = {};
            clearOldDataAndGetFreshData();
        }
        const currentFolderLevel = computed(() => {
            const folders = [];
            folders.push({
                name: t('common.home'),
                _id: '',
            });
            folders.push(...store.directoryRoute);
            return folders;
        });
        function onClickFolder(folder) {
            store.updateActiveObject('');
            if (!folder._id) {
                store.updateDirectory(null);
                return;
            }
            const directoryRoute = store.directoryRoute;
            const folderIndex = directoryRoute.findIndex((item) => item._id === folder._id);
            if (folderIndex !== directoryRoute.length - 1) {
                directoryRoute.splice(folderIndex + 1);
            }
        }
        function createFolder() {
            showFolderModal.value = true;
        }
        function setMediaLayout(value) {
            return __awaiter(this, void 0, void 0, function* () {
                loading.value = true;
                mediaLayout.value = value;
                store.activeItem = {};
                clearFileData();
                offset.value = initaializePagination.offset;
                limit.value = initaializePagination.limit;
                if (searchText.value) {
                    yield getFiles({ searchTerm: searchText.value });
                    loading.value = false;
                }
                else {
                    yield getFiles();
                    loading.value = false;
                }
            });
        }
        function paginatedQuery(value) {
            return __awaiter(this, void 0, void 0, function* () {
                loading.value = true;
                yield getFiles({ pageCount: value });
                loading.value = false;
            });
        }
        function noFileRender(category) {
            if (category === 'all') {
                return (files.value.length === 0 &&
                    folders.value.length === 0 &&
                    backgrounds.value.length === 0 &&
                    textures.value.length === 0 &&
                    pixabayImages.value.length === 0 &&
                    unsplashImages.value.length === 0);
            }
            else if (category === 'my_media') {
                return files.value.length === 0;
            }
            else if (category === 'backgrounds') {
                return backgrounds.value.length === 0 && textures.value.length === 0;
            }
            else if (category === 'unsplash') {
                return unsplashImages.value.length === 0 && searchText.value !== '';
            }
            else if (category === 'pixabay') {
                return pixabayImages.value.length === 0 && searchText.value !== '';
            }
        }
        watch(() => category.value, (newValue) => __awaiter(this, void 0, void 0, function* () {
            if (newValue === 'all' || newValue === 'backgrounds') {
                loading.value = true;
                if (backgrounds.value.length <= 0)
                    yield getBackgrounds();
                if (textures.value.length <= 0)
                    yield getTextures();
                loading.value = false;
            }
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "bg-white",
                onDrop: _withModifiers(addFilesFromDropZone, ["prevent"]),
                onDragover: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["prevent"]))
            }, [
                _createVNode(Header, {
                    onUploadMedia: customFileUpload,
                    onCreateFolder: createFolder,
                    onOnClickFolder: onClickFolder,
                    currentFolderLevel: currentFolderLevel.value,
                    onOpenImageGenerationForm: _unref(openImageGenerationForm),
                    contentAIEnable: contentAIEnable.value,
                    showContentAI: showContentAI.value
                }, null, 8, ["currentFolderLevel", "onOpenImageGenerationForm", "contentAIEnable", "showContentAI"]),
                _createVNode(MediaSearchBar, {
                    onSearch: _unref(onSearch),
                    onSetCategory: onSetCategory,
                    onSort: sortingOptions,
                    onSetMediaLayout: setMediaLayout
                }, null, 8, ["onSearch"]),
                _createElementVNode("input", {
                    type: "file",
                    ref_key: "fileRef",
                    ref: fileRef,
                    onChange: handleFileUpload,
                    hidden: "",
                    multiple: "multiple"
                }, null, 544),
                _createElementVNode("div", {
                    class: _normalizeClass(["px-4", {
                            'height-adjusted': isHeaderActive(),
                            'height-normal': !isHeaderActive(),
                        }]),
                    id: "drop_zone"
                }, [
                    _withDirectives(_createVNode(FoldersView, {
                        folders: folders.value,
                        category: category.value
                    }, null, 8, ["folders", "category"]), [
                        [_vShow, category.value == 'my_media' || category.value == 'all']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(PixabayImages, {
                        images: pixabayImages.value,
                        searchText: searchText.value,
                        category: category.value,
                        accordionVisible: accordionVisible.value,
                        key: key.value,
                        mediaLayout: mediaLayout.value
                    }, null, 8, ["images", "searchText", "category", "accordionVisible", "mediaLayout"])), [
                        [_vShow, category.value == 'pixabay' || category.value == 'all']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(UnsplashImages, {
                        images: unsplashImages.value,
                        searchText: searchText.value,
                        category: category.value,
                        accordionVisible: accordionVisible.value,
                        key: key.value,
                        mediaLayout: mediaLayout.value
                    }, null, 8, ["images", "searchText", "category", "accordionVisible", "mediaLayout"])), [
                        [_vShow, category.value == 'unsplash' || category.value == 'all']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(BackgroundsAndTextures, {
                        backgrounds: backgrounds.value,
                        textures: textures.value,
                        accordionVisible: accordionVisible.value,
                        key: key.value,
                        mediaLayout: mediaLayout.value,
                        category: category.value
                    }, null, 8, ["backgrounds", "textures", "accordionVisible", "mediaLayout", "category"])), [
                        [_vShow, category.value == 'backgrounds' || category.value == 'all']
                    ]),
                    _withDirectives(_createVNode(FilesView, {
                        files: files.value,
                        mediaLayout: mediaLayout.value,
                        count: mediaCount.value,
                        onPaginatedQuery: paginatedQuery,
                        category: category.value,
                        class: "mt-3"
                    }, null, 8, ["files", "mediaLayout", "count", "category"]), [
                        [_vShow, category.value == 'my_media' || category.value == 'all']
                    ]),
                    (loading.value == false && mediaLayout.value === 'grid' && noFileRender(category.value))
                        ? (_openBlock(), _createBlock(NoFile, { key: 0 }))
                        : _createCommentVNode("", true),
                    (loading.value == true && mediaLayout.value === 'grid')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createVNode(_unref(UISpin))
                        ]))
                        : _createCommentVNode("", true)
                ], 2),
                _createVNode(UploadingIndicator),
                (showFolderModal.value)
                    ? (_openBlock(), _createBlock(CreateFolderModal, {
                        key: 0,
                        parentId: selectedParentId.value,
                        onChangeClose: _cache[0] || (_cache[0] = ($event) => (showFolderModal.value = false)),
                        onUpdateUI: updateFolderData
                    }, null, 8, ["parentId"]))
                    : _createCommentVNode("", true)
            ], 32));
        };
    }
});
